export default __webpack_public_path__ + "static/media/travel-care-3.8af6f6f1.svg";